import { Button } from 'primereact/button';
import React from 'react';
import { handleDeleteRequest } from '../../services/DeleteTemplate';

function DeleteDialog({ onHideDeleteDialog, getUsers, dialogData }) {
    const handleDelete = async () => {
        const response = await handleDeleteRequest(`User/Delete${dialogData}`, true);
        if (response?.success === true) {
            getUsers();
            onHideDeleteDialog();
        }
    };
    return (
        <>
            <p style={{ textAlign: 'center' }}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="36" height="36" fill="#FF0101" aria-hidden="true" focusable="false">
                    <path d="M9 3a1 1 0 00-1 1v1H4a1 1 0 000 2h16a1 1 0 000-2h-4V4a1 1 0 00-1-1H9zm-3 6v10a2 2 0 002 2h8a2 2 0 002-2V9H6z" />
                </svg>
            </p>
            <p className=" mb-0" style={{ textAlign: 'center', fontSize: '20px', fontWeight: '500', marginTop: '-10px', color: '#000' }}>
                Delete
            </p>
            <p className="dialog__heading">Are you sure you want to delete this record?</p>
            <div className="flex mt-4 mb-2 justify-content-center">
                <Button label="Cancel" className="Btn__Transparent" style={{ width: '160px' }} onClick={onHideDeleteDialog} />
                <Button label="Delete" className="Btn__Send ml-2" style={{ width: '160px' }} onClick={handleDelete} />
            </div>
        </>
    );
}

export default DeleteDialog;
